<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <svg
    viewBox="0 0 502.645 149.99999"
    class="group"
    height="100%"
    v-if="cowilogo"
  >
    <defs>
      <clipPath clipPathUnits="userSpaceOnUse">
        <path

          d="m 907.03,0.574 331.017,0 0,185.603 -331.017,0 0,-185.603 z"
        />
      </clipPath>
    </defs>
    <g transform="translate(-90.93845,-363.57609)">
      <path
        d="m 374.24376,382.85356 c -1.34353,-4.21975 0.96035,-6.70795 5.18253,-6.70795 l 10.73854,0 0,-7.48399 -69.62831,0 0,7.48399 15.92107,0.0897 c 4.31676,0 7.95932,2.39847 9.3077,6.61821 l 41.99865,129.18742 15.82891,0 28.6749,-89.57269 27.61996,89.57269 18.1231,0 38.55737,-126.1196 c 1.82128,-6.32963 6.14046,-9.68603 12.46766,-9.68603 4.2246,0 6.52606,3.16239 6.52606,7.48399 l 0,113.35607 c 0,4.2246 -2.21173,7.47915 -6.52606,7.47915 l -23.39537,0 0,7.48642 87.943,0 0,-7.48642 -23.40506,0 c -4.2149,0 -6.52122,-3.25455 -6.52122,-7.47915 l 0,-113.35607 c 0,-4.3216 2.30632,-7.57373 6.52122,-7.57373 l 23.40506,0 0,-7.48399 -112.39814,0 0,7.48399 13.03514,0.0897 c 9.40229,0 12.9527,4.98126 10.25836,14.38597 l -26.65961,87.08448 -29.34423,-94.85222 c -1.34111,-4.21975 0.95793,-6.70795 5.08552,-6.70795 l 16.87658,0 0,-7.484 -69.62588,0 0,7.484 9.87761,0.0897 c 4.31918,0 7.96175,2.39847 9.30285,6.61822 l 7.00624,22.82303 -22.44228,70.10849 -30.31187,-92.93152 z M 239.20932,440.3998 c 0,37.30598 13.71661,65.3067 37.597,65.3067 23.7834,0 37.49515,-28.00072 37.49515,-65.3067 0,-37.40542 -13.71175,-65.40856 -37.49515,-65.40856 -23.7858,0 -37.597,28.00314 -37.597,65.40856 m -82.67315,-73.37273 c 10.64395,0 17.55561,2.97323 23.97981,6.80738 9.30044,5.4687 15.14745,3.3564 15.14745,-5.17283 l 0,-5.08553 7.57858,0 0,62.14432 -6.80738,0 c -3.83415,-32.89223 -17.17002,-50.72917 -39.89846,-50.72917 -26.37102,0 -37.59458,28.00314 -37.59458,65.40856 0,37.30598 11.22356,65.11511 37.59458,65.11511 32.60848,0 48.04937,-23.78096 53.70966,-65.11511 l 2.01529,-14.77398 c 4.98125,-34.33276 28.00314,-58.59875 64.5452,-58.59875 41.43359,0 66.55808,31.4614 66.55808,73.37273 0,41.90164 -25.12449,73.17629 -66.55808,73.17629 -32.51632,0 -54.37657,-19.09073 -62.33589,-47.47219 l -0.19887,-1.24895 -0.37832,2.01529 c -8.06118,24.45515 -22.16096,46.70585 -57.35707,46.70585 -41.52817,0 -65.59772,-31.27465 -65.59772,-73.17629 0,-41.91133 22.34285,-73.37273 65.59772,-73.37273"
        style="fill-opacity: 1; fill-rule: nonzero; stroke: none"
        :class="styles"
      />
    </g>
  </svg>
  <svg
    version="1.1"
    id="Layer_1"
    class="group"
    height="100%"
    viewBox="0 0 249.7 142.4"
    v-else
  >
    <style type="text/css">
      .st0 {
        fill: #006963;
      }
    </style>
    <g>
      <path
        :class="styles"
        d="M249.6,2.7c0,0,0,3.8,0.1,3.8l0,0l-13.1-0.1l0,0c-0.8,0.5-1.5,1.5-1.8,2.5l0,0l-0.1,55.1l0,0
		c0,2-0.2,4.9,2,5.7l0,0l1.3,0.5h11.5c-0.1,0,0,3.9,0,3.9h-43.2c-0.3,0-0.3-3.9-0.3-3.9l0,0l13.4-0.1l0,0c1-0.2,0.9-1.5,1.3-2.3l0,0
		l0.1-58.3l0,0c-0.2-0.9-0.8-1.8-1.7-2.3c-1.6-0.7-3.8-0.3-5.2,0.8c-1.7,1.4-2.6,3.4-3.3,5.2l0,0l-18.4,61h-9.1
		c-0.1,0-14.5-42.8-14.5-42.8s-14,42.8-13.9,42.7l0,0l-7.6,0.1l0,0c0.3,0-21.1-65-21.1-65c-2.1-4.3-7.9-1.8-11.7-2.5
		c-0.3,0.1,0-3.8,0-3.8h33.9c0,0,0,3.8,0.1,3.7c-2.4,0.6-5.5-0.4-7.6,0.5c-0.5,0.4-0.8,1-0.8,1.7l0,0l15.7,46.6l11-33.6l-4.4-13.3
		l0,0c-1.8-2.8-5.7-1.4-8.6-1.8c-0.1,0,0-3.8,0-3.8h34.7v3.8h-9.4c-0.8,0.3-1.8,0.8-2.1,1.7l0,0L176.8,9l15.1,47.5l13.4-42.7l0,0
		c0.2-2.2,0.2-4.7-1.8-6c-2.6-1.8-6.6-1-9.9-1.3c-0.2,0.1,0.1-3.8,0-3.8L249.6,2.7L249.6,2.7z M55.6,2.1c0.1,10,0.2,19.6,0.2,28.7
		c-1,0.4-2.2,0.3-3.3,0.2c-0.3-5.3-1.3-10.5-3.8-15.1C46,10.6,40.5,6.3,35,4.7c-6-1.3-11.6,1-15.3,5.8c-6.4,9.1-6.4,20.6-6,32.3
		c0.5,8.4,1.6,16.8,6.9,23.2c5.1,5.2,13.8,5.4,20.7,3.8c5.5-1.7,11.2-5.9,13.2-11.7c2.7-7.3,3.7-15.4,4.9-23.3
		c0.7-13.8,9-27.3,22.4-31.6c12.2-3.6,25.5-0.4,33.8,8.7c8.1,9.2,11.1,21.2,9.5,33.5c-1.3,8-4.7,15.5-10.8,21.4
		c-8.2,7.8-21,9.7-31.8,6.5c-7.5-2.3-15.2-8.1-19.1-15.5c-0.8-1.6-1.6-3.5-2.5-5.2l0,0l-0.5,0.5l0,0c-1.9,7.2-6.1,14.9-13.2,18.2
		c-6,3.9-14.7,4.5-21.5,2.2c-10.4-2.8-21.2-11.1-24-22c-1.8-6-2.2-12.7-1.4-19.3c1-12,8.7-24.5,20.3-28.9c5.4-2.2,13-3.8,18.9-0.8
		c3,1,5.2,3.7,8.5,4c1.8-0.3,3.4-1.6,4-3.5c0.7-1-0.5-3.3,1.4-3.1l0,0l2.1,0.2L55.6,2.1L55.6,2.1L55.6,2.1z M97.7,7
		c-4.6-2.1-10.4-1.3-14.2,1.4c-9.3,8-10,20.3-10.1,32c0.7,10.3,2,21.5,11,28c4.1,2.8,10.7,3.1,15,0.4c9.7-6.8,10.7-18.8,11.3-30
		c-0.1-9.3-1.4-18.1-6-25.7C102.9,10.7,100.5,8.2,97.7,7L97.7,7L97.7,7z"
      />
      <path
        :class="styles"
        d="M249.7,141.6V139c-6.7-0.6-7.9,0.1-7.9-5.2v-17.2c0-7.3-0.3-9.1-2.1-11.5c-2-2.5-5.7-4.1-9.8-4.1
		c-4.3,0-7.4,0.4-10.1,3.4c-2.5,2.7-3.1,4-4.4,8v-11.1c-3.5,0.3-10.5,0.7-16.4,0.8h-1.2v2.5c7.5,0.5,8.1-0.5,8.1,5.7v23.6
		c0,5.3-1.2,4.7-7.8,5.4v2.5h25V139c-6.7-0.6-7.6-0.2-7.6-5.3v-5.7c0-7.9,0.6-11,2.5-15.7c1.9-5,3.8-8.1,8.4-8.6
		c4.9-0.6,5.7,1.8,5.7,11.9v18.2c0,5.3-1.2,4.7-7.2,5.3v2.6L249.7,141.6L249.7,141.6z M170.9,119.8h26.7v-1.4
		c0-10.3-6.3-17.7-16.7-17.7c-11.1,0-19.7,9.5-19.7,20.9s8.7,20.7,20.8,20.7c8,0,12.9-4.1,14.8-10.7h-2c-0.3,0.9-0.6,1.7-1.3,2.9
		c-2.5,4-5.6,5.6-11.2,5.6c-8.2,0-11.5-4.2-11.5-16.4C170.8,122.4,170.8,121.7,170.9,119.8L170.9,119.8L170.9,119.8z M171.1,117.4
		c0.9-10.7,3.5-14.2,9.9-14.3c5.5,0,7.8,2.7,7.8,10.4c0,2.1,0,3.4-0.4,3.6c-0.4,0.2-2.5,0.2-6.6,0.2L171.1,117.4L171.1,117.4z
		 M163.1,139.4c-6.7-0.7-7.4-0.7-7.4-6.3V83.7l-17.6-0.1v2.5c7.2,0.4,8,0.7,8,7v17.5c-1.6-7.2-6-10.2-12.2-10.2
		c-10.5,0-19.3,9.6-19.3,21s8.3,20.9,18.6,20.9c3.5,0,6.8-1.2,9-3.3c1.8-1.7,2.6-1.9,4-5.6v8.6l17.2-0.1L163.1,139.4L163.1,139.4
		L163.1,139.4z M146.1,121.3c0,0.2-0.1-0.5-0.1-1.2c0-0.3,0-0.5-0.1-0.8c0,0,0,0,0,0c0,11.4-4,20.4-10.8,20.4
		c-3.8,0-7.1-1.5-8.3-5.6c-0.9-3.2-1.5-7.8-1.5-12.3c0-5.1,0.8-10.4,2-13.8c1.4-3.7,4.5-4.8,8.1-4.4c3.7,0.4,6.3,1.4,8,5.2
		c1.1,2.6,2.2,6,2.5,10.6c0,0,0,0.3,0.1,0.8C146.1,120.6,146.1,120.9,146.1,121.3L146.1,121.3L146.1,121.3z M116.3,139
		c-6.7-0.6-7.9,0.1-7.9-5.2v-17.2c0-7.3-0.3-9.1-2.1-11.5c-2-2.5-5.7-4.1-9.8-4.1c-4.3,0-7.4,0.4-10.2,3.4c-2.5,2.8-3.1,4-4.3,8
		v-11.1c-3.5,0.3-10.5,0.7-16.5,0.8h-1.1v2.5c7.5,0.5,8-0.6,8,5.7v23.6c0,5.3-1.2,4.7-7.8,5.4v2.5h24.8l-0.1-2.7
		c-6.7-0.6-7.3-0.1-7.3-5.2v-5.7c0-7.9,0.7-11,2.5-15.7c2-5,3.9-8.1,8.5-8.6c4.9-0.6,5.7,1.8,5.7,11.9v18.2c0,5.3-1.2,4.7-7.2,5.3
		l-0.1,2.6h24.8L116.3,139L116.3,139L116.3,139z M66.2,121.5c0-11.2-9.3-20.9-20.8-20.9s-20.6,9.7-20.6,20.9s9.2,20.9,20.6,20.9
		S66.2,132.7,66.2,121.5C66.2,121.5,66.2,121.5,66.2,121.5z M55.5,121.5c0,14.1-2.3,18.3-10,18.3s-10.1-4.2-10.1-18.3
		s2.4-18.3,10.2-18.3S55.5,107.4,55.5,121.5C55.5,121.5,55.5,121.5,55.5,121.5z M38.1,91.2c0-4.5-7.2-7.6-13.7-7.6
		c-4.2,0-8,1.2-10.8,3.7c-3.9,3.3-5.4,7-5.9,14.9H0v1.9h7.8v29.7c0,5.6-1.3,4.4-7.6,5.1L0,141.7h25.6l0.1-2.5
		c-6.9-0.6-8.3,0.1-8.3-5.4v-29.7h9.2v-1.9h-9.3v-7.5c0-7.2,1.7-9.1,6.6-9.1c2.3,0,4.9,4.6,5.1,5.4c1,2.5,1.5,4.9,4.3,4.9
		S38.1,93.9,38.1,91.2L38.1,91.2L38.1,91.2z"
      />
    </g>
  </svg>
</template>
<script setup lang="ts">
import { computed, toRefs } from "vue";

interface ILogoProps {
  color?: string;
  subsite?: string;
}

const props = withDefaults(defineProps<ILogoProps>(), {
  color: "orange",
});

const { color, subsite } = toRefs(props);

const styles = computed(() => {
  return `fill-${color.value}`;
});

const cowilogo = computed(() => {
  return subsite?.value != "cowiFonden";
});
</script>
